module.exports = __webpack_public_path__ + "img/lv6.876e56d1.png";